import React from 'react';
import './TripsHero.css';

function TripsHero({ searchQuery, setSearchQuery }) {
  return (
    <section className="trips-hero">
      <div 
        className="trips-hero-background"
        style={{
          backgroundImage: `url('/assets/imgs/destination/serengeti1.jpg')`
        }}
      >
        <div className="trips-hero-overlay"></div>
      </div>
      <div className="trips-hero-content">
        <h1 className="trips-hero-title">Our Tanzania Trips</h1>
        <p className="trips-hero-subtitle">
          Discover unforgettable safari experiences and adventure tours tailored to your dreams
        </p>
        <div className="trips-search">
          <input
            type="text"
            placeholder="Search tours by name, destination, or activity..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="trips-search-input"
          />
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="trips-search-icon"
          >
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default TripsHero;

